
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.493.287L4.957 3.822 1.422.287.244 1.465 3.78 5 .244 8.535l1.178 1.178 3.535-3.535 3.536 3.535 1.179-1.178L6.137 5l3.535-3.535L8.493.287z","fill":"#7E8186"}})])
          )
        }
      }
    